"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMcpSettings = getMcpSettings;
exports.setMcpSettings = setMcpSettings;
exports.setPreferredMcpSettings = setPreferredMcpSettings;
exports.getPreferredMcpLanguages = getPreferredMcpLanguages;
exports.setPreferredMcpLanguage = setPreferredMcpLanguage;
exports.getPreferredMcpRegionalSettings = getPreferredMcpRegionalSettings;
exports.setPreferredMcpRegionalSettings = setPreferredMcpRegionalSettings;
exports.getPreferredMcpTimezone = getPreferredMcpTimezone;
exports.setPreferredMcpTimezone = setPreferredMcpTimezone;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _CustomizrClient = _interopRequireDefault(require("./CustomizrClient"));

var _countryLanguage = _interopRequireDefault(require("country-language"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var mcpCustomizr = new _CustomizrClient["default"]({
  resource: 'mcp-generic-ui-settings'
});
/**
 * Return raw settings as stored in Customizr
 * @param {string} accessToken - Access token to use to call Customizr
 * @return {Promise<*|void>}
 */

function getMcpSettings(_x) {
  return _getMcpSettings.apply(this, arguments);
}
/**
 * Set raw settings in Customizr without any validation
 * @param {string} accessToken - Access token to use to call Customizr
 * @param {object} settings - Settings object. Only language, regionalSettings and timezone will be read
 * @return {Promise<void>}
 */


function _getMcpSettings() {
  _getMcpSettings = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee(accessToken) {
    var data;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return mcpCustomizr.getSettings(accessToken);

          case 2:
            data = _context.sent;

            if (!(Object.keys(data).length === 0)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", {
              language: ['en'],
              regionalSettings: 'en',
              timezone: 'America/New_York'
            });

          case 5:
            return _context.abrupt("return", data);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getMcpSettings.apply(this, arguments);
}

function setMcpSettings(_x2, _x3) {
  return _setMcpSettings.apply(this, arguments);
}
/**
 * Validate and update the preferred user settings at once
 * @param {string} accessToken - Access token to use to call Customizr
 * @param {string} languageCode - ISO-639 language code (eg. bul, en, eng, de)
 * @param {string} languageTag - RFC 4656 compliant language code (eg. en, en-US)
 * @param {string} timezone - IANA timezone (eg. Europe/Amsterdam)
 * @return {Promise<void>}
 */


function _setMcpSettings() {
  _setMcpSettings = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee2(accessToken, settings) {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return mcpCustomizr.putSettings(accessToken, {
              language: settings.language,
              regionalSettings: settings.regionalSettings,
              timezone: settings.timezone
            });

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _setMcpSettings.apply(this, arguments);
}

function setPreferredMcpSettings(_x4, _x5, _x6, _x7) {
  return _setPreferredMcpSettings.apply(this, arguments);
}
/**
 * Get the preferred language from Customizr
 * @param {string} accessToken
 * @return {Promise<*|Uint8Array|BigInt64Array|{lang: *, iso639_1: (string), iso639_2: *, iso639_3: *}[]|Float64Array|Int8Array|Float32Array|Int32Array|Uint32Array|Uint8ClampedArray|BigUint64Array|Int16Array|Uint16Array>}
 */


function _setPreferredMcpSettings() {
  _setPreferredMcpSettings = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee3(accessToken, languageCode, languageTag, timezone) {
    var preferredLanguage, preferredRegionalSettings, preferredTimezone, mcpSettings;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            preferredLanguage = (0, _utils.getValidLanguageOrThrow)(languageCode);
            preferredRegionalSettings = (0, _utils.getValidLanguageTagOrThrow)(languageTag);
            preferredTimezone = (0, _utils.getValidTimezoneOrThrow)(timezone);
            _context3.next = 5;
            return getMcpSettings(accessToken);

          case 5:
            mcpSettings = _context3.sent;
            _context3.next = 8;
            return mcpCustomizr.putSettings(accessToken, {
              language: (0, _utils.updatePreferredLanguage)(preferredLanguage, mcpSettings.language),
              regionalSettings: preferredRegionalSettings,
              timezone: preferredTimezone
            });

          case 8:
            return _context3.abrupt("return", _context3.sent);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _setPreferredMcpSettings.apply(this, arguments);
}

function getPreferredMcpLanguages(_x8) {
  return _getPreferredMcpLanguages.apply(this, arguments);
}
/**
 * Update the preferred language in Customizr
 * @param {string} accessToken - Access token to use to call Customizr
 * @param {string} languageCode - ISO-639 language code (eg. bul, en, eng, de)
 * @return {Promise<void>}
 */


function _getPreferredMcpLanguages() {
  _getPreferredMcpLanguages = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee4(accessToken) {
    var mcpSettings, twoLetterArray;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getMcpSettings(accessToken);

          case 2:
            mcpSettings = _context4.sent;
            twoLetterArray = mcpSettings.language || [];
            return _context4.abrupt("return", twoLetterArray.map(function (twoLetter) {
              var language = _countryLanguage["default"].getLanguages().find(function (a) {
                return a.iso639_1 === twoLetter;
              });

              return {
                lang: twoLetter,
                iso639_1: language ? language.iso639_1 : twoLetter,
                iso639_2: language ? language.iso639_2 : undefined,
                iso639_3: language ? language.iso639_3 : undefined
              };
            }));

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getPreferredMcpLanguages.apply(this, arguments);
}

function setPreferredMcpLanguage(_x9, _x10) {
  return _setPreferredMcpLanguage.apply(this, arguments);
}
/**
 * Get the preferred regional settings from Customizr
 * @param {string} accessToken - Access token to use to call Customizr
 * @return {Promise<string>}
 */


function _setPreferredMcpLanguage() {
  _setPreferredMcpLanguage = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee5(accessToken, languageCode) {
    var language, currentLanguages;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            language = (0, _utils.getValidLanguageOrThrow)(languageCode);
            _context5.next = 3;
            return getPreferredMcpLanguages(accessToken);

          case 3:
            currentLanguages = _context5.sent;
            return _context5.abrupt("return", mcpCustomizr.putSettings(accessToken, {
              language: (0, _utils.updatePreferredLanguage)(language, currentLanguages.map(function (l) {
                return l.iso639_1;
              }))
            }));

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _setPreferredMcpLanguage.apply(this, arguments);
}

function getPreferredMcpRegionalSettings(_x11) {
  return _getPreferredMcpRegionalSettings.apply(this, arguments);
}
/**
 * Update the preferred regional format in Customizr
 * @param {string} accessToken - Access token to use to call Customizr
 * @param {string} languageTag - RFC 4656 compliant language code (eg. en, en-US)
 * @return {Promise<void>}
 */


function _getPreferredMcpRegionalSettings() {
  _getPreferredMcpRegionalSettings = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee6(accessToken) {
    var mcpSettings;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return mcpCustomizr.getSettings(accessToken);

          case 2:
            mcpSettings = _context6.sent;
            return _context6.abrupt("return", mcpSettings.regionalSettings);

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getPreferredMcpRegionalSettings.apply(this, arguments);
}

function setPreferredMcpRegionalSettings(_x12, _x13) {
  return _setPreferredMcpRegionalSettings.apply(this, arguments);
}
/**
 * Get the preferred timezone from Customizr
 * @param {string} accessToken - Access token to use to call Customizr
 * @return {Promise<string>}
 */


function _setPreferredMcpRegionalSettings() {
  _setPreferredMcpRegionalSettings = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee7(accessToken, languageTag) {
    var regionalSettings;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            regionalSettings = (0, _utils.getValidLanguageTagOrThrow)(languageTag);
            return _context7.abrupt("return", mcpCustomizr.putSettings(accessToken, {
              regionalSettings: regionalSettings
            }));

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _setPreferredMcpRegionalSettings.apply(this, arguments);
}

function getPreferredMcpTimezone(_x14) {
  return _getPreferredMcpTimezone.apply(this, arguments);
}
/**
 * Update the preferred timezone from Customizr
 * @param {string} accessToken - Access token to use to call Customizr
 * @param {string} timezone - IANA timezone (eg. Europe/Amsterdam)
 * @return {Promise<void>}
 */


function _getPreferredMcpTimezone() {
  _getPreferredMcpTimezone = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee8(accessToken) {
    var mcpSettings;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return getMcpSettings(accessToken);

          case 2:
            mcpSettings = _context8.sent;
            return _context8.abrupt("return", mcpSettings.timezone);

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getPreferredMcpTimezone.apply(this, arguments);
}

function setPreferredMcpTimezone(_x15, _x16) {
  return _setPreferredMcpTimezone.apply(this, arguments);
}

function _setPreferredMcpTimezone() {
  _setPreferredMcpTimezone = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee9(accessToken, timezone) {
    var tz;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            tz = (0, _utils.getValidTimezoneOrThrow)(timezone);
            return _context9.abrupt("return", mcpCustomizr.putSettings(accessToken, {
              timezone: tz
            }));

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _setPreferredMcpTimezone.apply(this, arguments);
}